import { CDate, NGRX_BUCKETS, PriceComponent } from '@curbnturf/entities';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { buildOrder, OrderState } from './order.reducer';

// Lookup the 'Order' feature state managed by NgRx
export const getOrderState = createFeatureSelector<OrderState>(NGRX_BUCKETS.order);

export const getError = createSelector(getOrderState, (state: OrderState) => state.error);

export const getPriceError = createSelector(getOrderState, (state: OrderState) => state.priceError);

export const getOrder = createSelector(getOrderState, (state: OrderState) => {
  if (state.order && !state.order.built) {
    return buildOrder(state.order);
  }
  return {
    ...state.order,
    priceComponents: state.order.priceComponents?.map((price) => new PriceComponent(price)),
    date: new CDate(state.order.date),
  };
});

export const getPrices = createSelector(getOrderState, (state: OrderState) => {
  if (state.priceComponents) {
    return state.priceComponents.map((price) => new PriceComponent(price));
  }

  return [];
});

export const getDays = createSelector(getOrderState, (state: OrderState) => {
  return state.days;
});

export const orderQuery = {
  getError,
  getPriceError,
  getOrder,
  getPrices,
  getDays,
};
